(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nurdrin-mineral-drop"] && !Shopify.designMode) return;
  try {
    
class NurdrinProduct extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();

    const options = { signal: this.controller.signal };

    this.prelaunch = this.dataset.prelaunch !== 'false';
    this.form = this.querySelector('form');
    this.purchase = this.form || this.querySelector('[data-nd-purchase-preview]');
    this.image = this.querySelector('[data-nd-main-image]');

    this.addEventListener('click', event => {
      const photo = event.target.closest('[data-photo]');

      if (photo) {
        this.showPhoto(
          photo.dataset.photo,
          photo.dataset.alt,
          photo.dataset.photoWidth,
          photo.dataset.photoHeight
        );
      }
    }, options);

    if (!this.purchase) return;

    this.quantity = this.purchase.querySelector('input[name="quantity"]');
    this.submitButton = this.querySelector('[data-nd-submit]');
    this.status = this.querySelector('[data-nd-status]');
    this.error = this.querySelector('[data-nd-error]');

    this.money = new Intl.NumberFormat(
      document.documentElement.lang || 'de-DE',
      {
        style: 'currency',
        currency: this.dataset.currency || 'EUR'
      }
    );

    this.purchase.addEventListener('change', event => {
      if (event.target.matches('input[name="id"]')) {
        this.status.textContent = '';
        this.error.textContent = '';
        this.updateVariant();
      }
    }, options);

    this.quantity.addEventListener('input', () => this.updatePrice(), options);

    this.purchase.addEventListener('click', event => {
      const button = event.target.closest('[data-quantity-change]');
      if (!button || this.busy || this.prelaunch) return;

      const min = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      const current = Number(this.quantity.value);

      const base =
        this.quantity.checkValidity() && Number.isSafeInteger(current)
          ? current
          : min;

      this.quantity.value = Math.min(
        max,
        Math.max(min, base + Number(button.dataset.quantityChange) * step)
      );

      this.updatePrice();
    }, options);

    this.form?.addEventListener(
      'submit',
      event => this.addToCart(event),
      options
    );

    this.updateVariant();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  get selected() {
    return this.purchase?.querySelector('input[name="id"]:checked');
  }

  showPhoto(url, alt, width, height) {
    if (!this.image || !url) return;

    const source = new URL(url, document.baseURI);
    const maximum = Math.min(Number(width) || 2400, 3200);

    source.searchParams.set('width', String(maximum));

    const widths = [360, 540, 750, 1000, 1400, 2000, 2800]
      .filter(value => value < maximum);

    widths.push(maximum);

    this.image.sizes = this.dataset.imageSizes || '100vw';

    this.image.srcset = widths.map(value => {
      const candidate = new URL(source);
      candidate.searchParams.set('width', String(value));
      return candidate.href + ' ' + value + 'w';
    }).join(', ');

    this.image.src = source.href;

    if (Number(width) > 0 && Number(height) > 0) {
      this.image.width = Number(width);
      this.image.height = Number(height);

      const frame = this.image.closest('.nd-photo');
      frame?.style.setProperty('--nd-native-width', width + 'px');
      frame?.style.setProperty('--nd-native-height', height + 'px');
    }

    this.image.alt = alt || 'NURDRIN Minuvio Elektrolyte';

    this.querySelectorAll('[data-photo]').forEach(button => {
      button.setAttribute(
        'aria-pressed',
        String(button.dataset.photo === url)
      );
    });
  }

  updateVariant() {
    const variant = this.selected;

    if (!variant) {
      this.submitButton.disabled = true;
      return;
    }

    const productInput = this.purchase.querySelector('input[name="product-id"]');

    if (productInput) {
      productInput.value = variant.dataset.productId;
    }

    this.querySelectorAll('[data-nd-description-product]').forEach(description => {
      description.hidden =
        description.dataset.ndDescriptionProduct !== variant.dataset.productId;
    });

    const shippingNote = this.querySelector('[data-nd-shipping-note]');

    if (shippingNote) {
      shippingNote.hidden = this.prelaunch || variant.dataset.units !== '3';
    }

    this.quantity.min = variant.dataset.min || '1';
    this.quantity.step = variant.dataset.step || '1';
    this.quantity.max = variant.dataset.max || '';

    const min = Number(this.quantity.min);
    const step = Number(this.quantity.step);
    const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
    const previous = Number(this.quantity.value) || min;

    this.quantity.value = Math.min(
      max,
      Math.max(min, min + Math.floor((previous - min) / step) * step)
    );

    this.showPhoto(
      variant.dataset.image,
      'NURDRIN Minuvio – ' + variant.dataset.title,
      variant.dataset.imageWidth,
      variant.dataset.imageHeight
    );

    this.updatePrice();
  }

  updatePrice() {
    const variant = this.selected;
    if (!variant) return;

    const quantity = Number(this.quantity.value);
    const valid =
      Number.isSafeInteger(quantity) && this.quantity.checkValidity();

    const amount = valid ? quantity : 1;
    const price = Number(variant.dataset.price);
    const available = variant.dataset.available === 'true';

    this.querySelector('[data-nd-price]').textContent =
      this.money.format(price * amount / 100);

    const unitPrice = this.querySelector('[data-nd-unit-price]');

    if (unitPrice) {
      const formattedUnitPrice = variant.dataset.unitPrice || '';
      unitPrice.hidden = !formattedUnitPrice;
      unitPrice.querySelector('[data-nd-unit-price-value]').textContent =
        formattedUnitPrice;
    }

    const vatNote = this.querySelector('[data-nd-vat-note]');
    const taxNote = this.querySelector('[data-nd-tax-note]');

    if (vatNote) {
      vatNote.hidden = variant.dataset.taxable !== 'true';
      vatNote.querySelector('[data-nd-vat-amount]').textContent =
        this.money.format(Math.round(price * amount * 19 / 119) / 100);
    }

    if (taxNote) {
      taxNote.hidden = Boolean(vatNote && !vatNote.hidden);
    }

    const priceShipping = this.querySelector('[data-nd-price-shipping]');

    if (priceShipping) {
      priceShipping.textContent = variant.dataset.units === '3'
        ? 'versandkostenfrei innerhalb Deutschlands'
        : 'zzgl. Versandkosten';
    }

    const comparison = this.querySelector('[data-nd-comparison-price]');

    if (comparison) {
      const comparisonPrice = Number(variant.dataset.comparisonPrice) || 0;

      comparison.hidden =
        variant.dataset.units !== '3' || comparisonPrice <= price;

      comparison.textContent =
        this.money.format(comparisonPrice * amount / 100);
    }

    this.querySelector('[data-nd-quantity-error]').hidden =
      this.prelaunch || valid;

    this.querySelector('[data-nd-stock]').hidden =
      this.prelaunch || available;

    const dispatch = this.querySelector('[data-nd-dispatch]');

    if (dispatch) {
      dispatch.hidden = this.prelaunch || !available;
    }

    this.submitButton.disabled = Boolean(
      this.prelaunch || this.busy || !available || !valid
    );

    this.querySelector('[data-nd-submit-label]').textContent =
      this.prelaunch
        ? 'Bald verfügbar'
        : this.busy
          ? 'Wird hinzugefügt …'
          : 'In die Tasche packen';

    this.querySelector('[data-quantity-change="-1"]').disabled = Boolean(
      this.prelaunch ||
      this.busy ||
      quantity <= Number(this.quantity.min)
    );

    this.querySelector('[data-quantity-change="1"]').disabled = Boolean(
      this.prelaunch ||
      this.busy ||
      (this.quantity.max && quantity >= Number(this.quantity.max))
    );
  }

  setBusy(busy) {
    this.busy = busy;
    this.querySelector('.nd-box-options').disabled = busy;
    this.quantity.disabled = busy || this.prelaunch;
    this.submitButton.setAttribute('aria-busy', String(busy));
    this.updatePrice();
  }

  async addToCart(event) {
    event.preventDefault();

    if (
      this.prelaunch ||
      this.busy ||
      !this.form ||
      !this.form.reportValidity()
    ) return;

    const variant = this.selected;
    const quantity = Number(this.quantity.value);

    if (
      !variant ||
      variant.dataset.available !== 'true' ||
      !Number.isSafeInteger(quantity)
    ) return;

    this.status.textContent = '';
    this.error.textContent = '';

    const variantId = variant.value;

    const sections = [
      ...new Set(
        Array.from(
          document.querySelectorAll('cart-items-component[data-section-id]'),
          element => element.dataset.sectionId
        )
      )
    ].slice(0, 5);

    const payload = {
      items: [{ id: variantId, quantity }],
      sections_url: location.pathname
    };

    if (sections.length) {
      payload.sections = sections;
    }

    this.setBusy(true);

    try {
      const response = await fetch(this.dataset.addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (!response.ok || result.status >= 400) {
        throw new Error(
          result.description ||
          result.message ||
          'Das Produkt konnte nicht hinzugefügt werden.'
        );
      }

      this.status.textContent =
        quantity + ' × ' + variant.dataset.title +
        ' zur Tasche hinzugefügt.';

      try {
        await this.refreshCart(result, variantId, quantity);
      } catch {
        this.status.textContent +=
          ' Öffne die Tasche oben im Menü, um den aktuellen Inhalt zu sehen.';
      }
    } catch (error) {
      this.error.textContent =
        error instanceof TypeError || error instanceof SyntaxError
          ? 'Die Antwort konnte nicht bestätigt werden. Prüfe deine Tasche, bevor du erneut hinzufügst.'
          : error.message;
    } finally {
      this.setBusy(false);
    }
  }

  async refreshCart(result, variantId, quantity) {
    const { CartLinesUpdateEvent } = await import('@shopify/events');

    const response = await fetch(this.dataset.cartUrl, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('cart-refresh');
    }

    const cart = await response.json();

    const drawers = Array.from(
      document.querySelectorAll('cart-drawer-component[auto-open]')
    );

    drawers.forEach(drawer => {
      drawer.removeAttribute('auto-open');
    });

    try {
      this.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: variantId, quantity }],
          promise: Promise.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'nurdrin-product',
              sourceId: this.form.id,
              itemCount: cart.item_count,
              sections: result.sections,
              didError: false
            }
          })
        })
      );
    } finally {
      drawers.forEach(drawer => {
        drawer.setAttribute('auto-open', '');
      });
    }
  }
}

if (!customElements.get('nurdrin-product')) {
  customElements.define('nurdrin-product', NurdrinProduct);
}

class NurdrinExtras extends HTMLElement {
  connectedCallback() {
    this.cleanup();
    this.controller = new AbortController();

    const options = { signal: this.controller.signal };
    this.status = this.querySelector('[data-nd-footer-status]');

    this.closeFaqs();

    window.addEventListener('pageshow', () => {
      this.closeFaqs();
      this.updateNavigation();
    }, options);

    window.addEventListener('hashchange', () => {
      this.updateNavigation(true);
    }, options);

    const scheduleNavigation = () => {
      if (this.navigationFrame) return;

      this.navigationFrame = requestAnimationFrame(() => {
        this.navigationFrame = 0;
        this.updateNavigation();
      });
    };

    window.addEventListener('scroll', scheduleNavigation, {
      ...options,
      passive: true
    });

    window.addEventListener('resize', scheduleNavigation, options);

    this.addEventListener('click', event => {
      const pending = event.target.closest('[data-nd-pending]');
      const cookies = event.target.closest('[data-nd-cookies]');

      if (pending) {
        this.status.textContent =
          pending.dataset.ndPending === 'Instagram'
            ? 'Unser Instagram-Link folgt in Kürze.'
            : pending.dataset.ndPending + ': Diese Seite wird gerade vorbereitet.';
      }

      if (cookies) {
        this.openCookies(cookies);
      }
    }, options);

    const mount = () => {
      this.mountHeader();
      this.mountCart();
    };

    document.addEventListener('DOMContentLoaded', mount, options);
    document.addEventListener('shopify:section:load', mount, options);
    document.addEventListener('theme-drawer:open', mount, options);

    mount();
    this.updateNavigation(true);
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cleanup() {
    this.controller?.abort();
    this.observer?.disconnect();

    cancelAnimationFrame(this.frame || 0);
    this.frame = 0;
    this.drawer = null;

    cancelAnimationFrame(this.navigationFrame || 0);
    this.navigationFrame = 0;
  }

  closeFaqs() {
    this.closest('[id^="nd-"]')
      ?.querySelectorAll('.nd-product-details details')
      .forEach(details => {
        details.open = false;
      });
  }

  mountHeader() {
    const template = document.getElementById('nd-horizon-content');
    const header = document.getElementById('header-component');

    const navigation = [
      template?.content.querySelector('.nd-links'),
      header?.querySelector('.nd-links')
    ];

    navigation.forEach(nav => {
      if (!nav) return;

      let link = nav.querySelector('[data-nd-home-link]');

      if (!link) {
        link = document.createElement('a');
        link.dataset.ndHomeLink = '';
        link.textContent = 'Startseite';
        nav.append(link);
      }

      link.setAttribute('href', this.dataset.homeUrl || '/');

      nav.querySelectorAll('a').forEach(item => {
        const url = new URL(item.href, window.location.href);

        if (item.hasAttribute('data-nd-home-link')) {
          item.dataset.ndNavigation = 'home';
        } else if (url.hash === '#nurdrin-story') {
          item.dataset.ndNavigation = 'story';
        } else if (url.pathname.includes('/products/')) {
          item.dataset.ndNavigation = 'product';
        }
      });
    });

    this.updateNavigation();
  }

  updateNavigation(preferHash = false) {
    const header = document.getElementById('header-component');
    const template = document.getElementById('nd-horizon-content');

    let active = this.dataset.pageType === 'product' ? 'product' : '';

    if (this.dataset.pageType === 'index') {
      active = 'home';

      const story = document.getElementById('nurdrin-story');
      const bounds = story?.getBoundingClientRect();

      const marker = Math.max(
        header?.getBoundingClientRect().bottom || 0,
        window.innerHeight * 0.35
      );

      const inStory =
        bounds && bounds.top <= marker && bounds.bottom > marker;

      if (
        inStory ||
        (preferHash && window.location.hash === '#nurdrin-story')
      ) {
        active = 'story';
      }
    }

    [header, template?.content].forEach(root => {
      root?.querySelectorAll('.nd-links a').forEach(link => {
        if (active && link.dataset.ndNavigation === active) {
          link.setAttribute(
            'aria-current',
            active === 'story' ? 'location' : 'page'
          );
        } else {
          link.removeAttribute('aria-current');
        }
      });
    });
  }

  mountCart() {
    if (this.dataset.language !== 'de') return;

    const drawer = document.getElementById('cart-drawer');

    if (drawer === this.drawer && this.observer) {
      this.refreshCartText();
      return;
    }

    this.observer?.disconnect();
    this.drawer = drawer;

    if (!drawer) return;

    this.refreshCartText();

    this.observer = new MutationObserver(() => {
      if (this.frame) return;

      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.refreshCartText();
      });
    });

    this.observer.observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  refreshCartText() {
    const setText = (element, value) => {
      if (element && element.textContent.trim() !== value) {
        element.textContent = value;
      }
    };

    setText(
      this.drawer?.querySelector('.cart-totals__total-label'),
      'Gesamtbetrag'
    );

    const note = this.drawer?.querySelector('.cart-totals__tax-note');

    setText(
      note?.querySelector('small') || note,
      'Inkl. MwSt. Eventuelle Versandkosten werden beim Checkout berechnet.'
    );
  }

  async openCookies(button) {
    if (button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    this.status.textContent = '';

    try {
      const banner = await this.loadPrivacyBanner();
      await banner.showPreferences();
    } catch {
      this.status.textContent =
        'Die Cookie-Einstellungen sind gerade nicht verfügbar. Bitte lade die Seite neu und versuche es erneut.';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  loadPrivacyBanner() {
    if (typeof window.privacyBanner?.showPreferences === 'function') {
      return Promise.resolve(window.privacyBanner);
    }

    if (!window.__ndPrivacyBannerPromise) {
      window.__ndPrivacyBannerPromise = new Promise((resolve, reject) => {
        const src =
          'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';

        const existing = document.querySelector('script[src="' + src + '"]');
        const script = existing || document.createElement('script');
        let timer;

        const cleanup = () => {
          clearTimeout(timer);
          script.removeEventListener('load', loaded);
          script.removeEventListener('error', failed);
        };

        const failed = () => {
          cleanup();
          if (!existing) script.remove();
          reject(new Error('privacy-banner-unavailable'));
        };

        const loaded = () => {
          if (typeof window.privacyBanner?.showPreferences !== 'function') {
            failed();
            return;
          }

          cleanup();
          resolve(window.privacyBanner);
        };

        script.addEventListener('load', loaded, { once: true });
        script.addEventListener('error', failed, { once: true });

        timer = setTimeout(failed, 8000);

        if (!existing) {
          script.src = src;
          script.async = true;
          document.head.append(script);
        }
      }).catch(error => {
        window.__ndPrivacyBannerPromise = null;
        throw error;
      });
    }

    return window.__ndPrivacyBannerPromise;
  }
}

if (!customElements.get('nurdrin-extras')) {
  customElements.define('nurdrin-extras', NurdrinExtras);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nurdrin-pfotenspur"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nurdrin-paw-trail')) {
    class NurdrinPawTrail extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const mount = () => this.mount();

        document.addEventListener('DOMContentLoaded', mount, options);
        document.addEventListener('shopify:section:load', mount, options);

        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(this.root)) this.detach();
        }, options);

        window.addEventListener('resize', () => this.schedule(), options);
        window.addEventListener('pageshow', mount, options);

        document.fonts?.ready.then(() => {
          if (this.isConnected) this.schedule();
        });

        this.mount();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.detach();
      }

      detach() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame || 0);
        this.frame = 0;
        this.svg?.remove();

        if (this.svg) {
          this.root?.classList.remove('nd-paw-enabled');
        }

        this.svg = null;
        this.root = null;
      }

      mount() {
        const root = document.querySelector('.nd:not(.nd--product)');

        if (!root) {
          this.detach();
          return;
        }

        if (root === this.root && this.svg?.isConnected) {
          this.schedule();
          return;
        }

        this.detach();

        if (root.querySelector('.nd-paw-layer')) return;

        this.root = root;

        this.svg = this.element('svg', {
          class: 'nd-paw-layer',
          hidden: '',
          'aria-hidden': 'true',
          focusable: 'false',
          preserveAspectRatio: 'none'
        });

        this.root.append(this.svg);

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.schedule());
          this.observer.observe(this.root);

          this.root.querySelectorAll('section, .nd-footer').forEach(section => {
            this.observer.observe(section);
          });
        }

        this.schedule();
      }

      schedule() {
        if (!this.root || this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.draw();
        });
      }

      element(name, attributes = {}) {
        const element = document.createElementNS(
          'http://www.w3.org/2000/svg',
          name
        );

        Object.entries(attributes).forEach(([key, value]) => {
          element.setAttribute(key, String(value));
        });

        return element;
      }

      draw() {
        if (!this.root?.isConnected || !this.svg) return;

        const mobile = this.root.clientWidth <= 700;
        const visible = !mobile || this.dataset.mobile !== 'false';

        this.root.classList.toggle('nd-paw-enabled', visible);
        this.svg.toggleAttribute('hidden', !visible);

        if (!visible) return;

        const box = this.root.getBoundingClientRect();

        if (box.width < 100 || box.height < 100) return;

        const rectangle = selector => {
          const element = this.root.querySelector(selector);

          if (!element) return null;

          const rect = element.getBoundingClientRect();

          return {
            top: rect.top - box.top,
            bottom: rect.bottom - box.top,
            left: rect.left - box.left,
            right: rect.right - box.left,
            height: rect.height
          };
        };

        const hero = rectangle('.nd-hero');
        const ingredients = rectangle('.nd-ingredients');
        const story = rectangle('#nurdrin-story');
        const teaser = rectangle('.nd-teaser');
        const community = rectangle('.nd-community');
        const footer = rectangle('.nd-footer');
        const container = rectangle('.nd-hero .nd-container');

        if (![hero, ingredients, story, teaser, container].every(Boolean)) {
          this.svg.replaceChildren();
          return;
        }

        const width = box.width;
        const gutter = Math.min(container.left, width - container.right);
        const left = Math.max(16, gutter / 2);
        const right = width - left;
        const sway = Math.max(0, Math.min(60, gutter * 0.18 - 6));

        const size = mobile ? 14 : width < 1380 ? 18 : 24;
        const stride = mobile ? 102 : 94;
        const offset = mobile ? 3 : width < 1380 ? 4 : 7;
        const gap = mobile ? 24 : 34;

        const points = [];
        let previous = {
          x: left + sway,
          y: hero.top + 16
        };

        points.push(previous);

        const curve = (x1, y1, x2, y2, x3, y3) => {
          const start = previous;

          const steps = Math.max(
            18,
            Math.ceil((
              Math.hypot(x1 - start.x, y1 - start.y) +
              Math.hypot(x2 - x1, y2 - y1) +
              Math.hypot(x3 - x2, y3 - y2)
            ) / 10)
          );

          for (let index = 1; index <= steps; index++) {
            const t = index / steps;
            const u = 1 - t;

            points.push({
              x:
                u ** 3 * start.x +
                3 * u ** 2 * t * x1 +
                3 * u * t ** 2 * x2 +
                t ** 3 * x3,
              y:
                u ** 3 * start.y +
                3 * u ** 2 * t * y1 +
                3 * u * t ** 2 * y2 +
                t ** 3 * y3
            });
          }

          previous = { x: x3, y: y3 };
        };

        curve(
          left - sway, hero.top + hero.height * .22,
          left - sway, hero.top + hero.height * .65,
          left + sway, hero.bottom - gap
        );

        curve(
          left + sway, ingredients.top + gap,
          width * .32, ingredients.top + gap,
          width * .52, ingredients.top + gap
        );

        curve(
          width * .75, ingredients.top + gap,
          right, ingredients.top + gap,
          right, ingredients.top + gap * 1.6
        );

        curve(
          right + sway * .3, ingredients.top + ingredients.height * .55,
          right - sway * .3, ingredients.bottom - 70,
          right, story.top + gap
        );

        curve(
          right + sway * .2, story.top + story.height * .32,
          right + sway * .2, story.bottom - gap * 2,
          right - sway * .2, story.bottom - gap
        );

        curve(
          right - sway, story.bottom - gap * .45,
          width * .67, story.bottom - gap,
          width * .46, story.bottom - gap
        );

        curve(
          width * .27, story.bottom - gap,
          left, story.bottom - gap * 1.5,
          left, teaser.top + gap
        );

        curve(
          left - sway * .65, teaser.top + teaser.height * .3,
          left + sway * .55, teaser.top + teaser.height * .75,
          left, teaser.bottom - 12
        );

        if (community) {
          curve(
            left - sway * .2, community.top + community.height * .3,
            left + sway * .2, community.bottom - 35,
            left, footer ? footer.top + 25 : community.bottom - 12
          );
        }

        const lengths = [0];

        for (let index = 1; index < points.length; index++) {
          lengths.push(
            lengths[index - 1] + Math.hypot(
              points[index].x - points[index - 1].x,
              points[index].y - points[index - 1].y
            )
          );
        }

        const total = lengths[lengths.length - 1];

        const strength = Math.max(
          0.06,
          Math.min(0.32, (Number(this.dataset.strength) || 18) / 100)
        );

        const fragment = document.createDocumentFragment();
        const shapeId = this.root.id + '-paw-shape';
        const definitions = this.element('defs');
        const shape = this.element('g', { id: shapeId });

        shape.append(this.element('path', {
          d: 'M-7 1C-5-3-2-4 0-2C2-4 6-2 8 2C10 5 12 8 9 11C7 13 4 12 2 11C0 14-3 13-5 11C-8 13-12 10-11 7C-10 4-8 3-7 1Z'
        }));

        [
          [-10, -5, 3.2, 4.5, -25],
          [-4, -11, 3.3, 4.7, -9],
          [4, -11.5, 3.4, 4.8, 9],
          [10, -5.5, 3.1, 4.4, 27]
        ].forEach(toe => {
          shape.append(this.element('ellipse', {
            cx: toe[0],
            cy: toe[1],
            rx: toe[2],
            ry: toe[3],
            transform: `rotate(${toe[4]} ${toe[0]} ${toe[1]})`
          }));
        });

        definitions.append(shape);
        fragment.append(definitions);

        let segment = 1;
        let number = 0;

        for (
          let distance = 22;
          distance < total - 12 && number < 180;
          distance += stride
        ) {
          while (
            segment < lengths.length - 1 &&
            lengths[segment] < distance
          ) {
            segment++;
          }

          const a = points[segment - 1];
          const b = points[segment];
          const length = lengths[segment] - lengths[segment - 1];

          if (length < .001) continue;

          const t = (distance - lengths[segment - 1]) / length;
          const dx = (b.x - a.x) / length;
          const dy = (b.y - a.y) / length;
          const side = number % 2 ? 1 : -1;

          const x = a.x + (b.x - a.x) * t - dy * offset * side;
          const y = a.y + (b.y - a.y) * t + dx * offset * side;

          const angle = Math.atan2(dy, dx) * 180 / Math.PI + 90;

          const fade = Math.min(
            1,
            distance / 170,
            (total - distance) / 170
          );

          const dark =
            community &&
            y >= community.top &&
            y < community.bottom;

          fragment.append(this.element('use', {
            href: '#' + shapeId,
            transform:
              `translate(${x.toFixed(2)} ${y.toFixed(2)}) ` +
              `rotate(${angle.toFixed(2)}) ` +
              `scale(${(size / 32 * side).toFixed(3)} ${(size / 32).toFixed(3)})`,
            fill: dark ? '#d5dfc9' : '#36513c',
            opacity:
              (strength * fade * (number % 2 ? .9 : 1)).toFixed(3)
          }));

          number++;
        }

        this.svg.setAttribute(
          'viewBox',
          `0 0 ${width} ${box.height}`
        );

        this.svg.setAttribute('width', width);
        this.svg.setAttribute('height', box.height);
        this.svg.replaceChildren(fragment);
      }
    }

    customElements.define('nurdrin-paw-trail', NurdrinPawTrail);
  }

  } catch(e) { console.error(e); }
})();
})();
